import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from 'react';
import { adminLogin, adminMe } from '../api';

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('iv_admin_token');
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const data = await adminMe();
      setUser({ username: data.username, role: data.role || 'admin' });
    } catch (err) {
      console.warn('Auth refresh failed:', err?.response?.status || err?.message);
      localStorage.removeItem('iv_admin_token');
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (username, password) => {
    const res = await adminLogin(username, password);
    localStorage.setItem('iv_admin_token', res.access_token);
    setUser({ username: res.username, role: res.role || 'admin' });
    return res;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('iv_admin_token');
    setUser(null);
  }, []);

  const value = useMemo(() => ({ user, loading, login, logout, refresh }), [user, loading, login, logout, refresh]);

  return (
    <AuthCtx.Provider value={value}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
